import React, { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from 'react-router-dom';
import AuthService from "../services/AuthService";
import { LiaShoppingBagSolid } from "react-icons/lia";
import { LiaUserCircleSolid } from "react-icons/lia";
import { LiaSignOutAltSolid } from "react-icons/lia";
import { MdHomeFilled, MdHomeWork, MdOutlineArrowDropDown } from "react-icons/md";
import { CiHome, CiSearch } from "react-icons/ci";
import { MdOutlineKeyboardArrowLeft } from "react-icons/md";



const Header = ({ title, back = -1 }) => {
    const [activeTab, setActiveTab] = useState(localStorage.getItem('type') || 'delivery');
    const address = JSON.parse(localStorage.getItem("address"));
    const branch = JSON.parse(localStorage.getItem("branch"));
    const isAuthenticated = AuthService.getCurrentUser();
    const navigate = useNavigate();
    const searchParams = new URLSearchParams(window.location.search);
    const tabParam = searchParams.get('tab');
    const cart_count = localStorage.getItem('cart_count') || 0;

    useEffect(() => {
        window.scrollTo(0, 0);
        if (tabParam) {
            setActiveTab(tabParam);
        }
    }, [tabParam]);

    const logout = async () => {
        AuthService.logout();
        navigate('/login');
    }



  return (
    <>
        <div className="top-bar d-flex justify-content-between px-4 py-4 ">
            {title == 'Home' ?(
                <div>
                    {branch && activeTab=='pickup' ?(
                        <div className="top-bar-left">
                        <span className="text-secondary">Pickup From</span>
                        <p className="mb-0">
                            <Link to="/?tab=pickup&change=true" className="text-base">
                            {branch?.name ?? 'Select Branch'}
                            <MdOutlineArrowDropDown className="chevron-down fs-4" />
                            </Link>
                        </p>
                        </div>
                        
                    ):(
                        <div className="top-bar-left">
                        <span className="text-secondary">Deliver to</span>
                        <p className="mb-0">
                            <Link to="/address-list" className="text-base">
                            {address?.area ?? 'Add Address'}
                            <MdOutlineArrowDropDown className="chevron-down fs-4" />
                            </Link>
                        </p>
                        </div>
                    )}
                </div>

            ):(
                <div className="top-bar-left d-flex align-items-center">
                    <span>

                    <Link to={back}>
                        <MdOutlineKeyboardArrowLeft className="chevron-left-itemsDetails shadow" />
                    </Link>
                    </span>
                    <span className="fs-6">{title}</span>
                </div>

            )}
            
            

            
            <div className="top-bar-right d-flex align-items-center">
                { (!isAuthenticated || isAuthenticated?.is_guest) ? (
                    <Link to="/login">
                        {/* <LiaUserCircleSolid className="top-bar-search-icon fs-2 mx-2 fw-semibold text-secondary" /> */}
                    </Link>
                ):(
                <>
                    <Link to="/account">
                        <span className="text-secondary mx-2">Hi, {isAuthenticated.name}</span>
                    </Link>
                    
                </>
                )}
                <Link  to="/">
                        <MdHomeFilled  className="top-bar-search-icon fs-2 mx-2 fw-semibold text-secondary"  />
                    </Link>
                <Link to="/cart">
                    {cart_count > 0 &&
                        <span className="cart-count">{cart_count}</span>
                    }
                    <LiaShoppingBagSolid className="top-bar-search-icon fs-2 mx-2 fw-semibold text-secondary" />
                </Link>
                <Link to="/search">
                    <CiSearch className="top-bar-search-icon fs-2 text-secondary" />
                </Link>

            </div>

        </div>
    </>
  );
};

export default Header;
